import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import StoneSizeForm from '../../../../components/masters/stoneAttribute/stoneSize/StoneSizeForm';
import StoneSizeTable from '../../../../components/masters/stoneAttribute/stoneSize/StoneSizeTable';
import { fetchStoneSizes, addStoneSize, updateStoneSize, deleteStoneSize, setStoneSizeEdit, clearStoneSizeEdit } from '../../../../redux/actions/masters/stoneAttribute/stoneSize/stoneSizeAction';
import { fetchCompanies } from '../../../../api/masters/company/companyApi';
import { fetchSieveSizes } from '../../../../api/masters/stoneAttribute/sieveSize/sieveSizeApi';
import { fetchUsers } from '../../../../redux/actions/masters/users/user/userAction';

const outerWrapper = {
  padding: 0,
  margin: 0,
  minHeight: 'calc(100vh - 72px)',
  display: 'flex',
  flexDirection: 'column',
  background: 'transparent',
  marginTop: 24,
};

const containerStyle = {
  display: 'flex',
  flexDirection: 'row',
  gap: 24,
  alignItems: 'stretch',
  width: '100%',
  height: '100%',
  flex: 1,
};

const cardBase = {
  background: '#fff',
  borderRadius: 16,
  boxShadow: '0 2px 16px rgba(0,0,0,0.07)',
  padding: '2rem 1.5rem',
  display: 'flex',
  flexDirection: 'column',
  minWidth: 320,
  flex: 1,
  minHeight: 520,
};

const tableContainer = {
  ...cardBase,
  flex: 2,
  minWidth: 340,
  marginRight: 0,
};
const formContainer = {
  ...cardBase,
  maxWidth: 400,
  flex: '0 1 400px',
  marginLeft: 0,
};

const responsiveStyle = `
@media (max-width: 900px) {
  .stone-size-flex {
    flex-direction: column !important;
    gap: 20px !important;
  }
  .stone-size-form, .stone-size-table {
    max-width: 100% !important;
    min-width: 0 !important;
    width: 100% !important;
  }
}
`;

const StoneSizePage = () => {
  const dispatch = useDispatch();
  const { list = [], loading, editingStoneSize, formSuccess, formError } = useSelector(state => state.stoneSize || {});
  const users = useSelector(state => state.users.list || []);
  const [companies, setCompanies] = useState([]);
  const [sieveSizes, setSieveSizes] = useState([]);
  const [formSuccessMsg, setFormSuccessMsg] = useState('');
  const [formErrorMsg, setFormErrorMsg] = useState('');
  const [formResetKey, setFormResetKey] = useState(0);

  useEffect(() => {
    dispatch(fetchStoneSizes());
    dispatch(fetchUsers());
    fetchCompanies().then(data => setCompanies(data.filter(c => c.trash === 0)));
    fetchSieveSizes().then(data => setSieveSizes(data.filter(s => s.trash === 0)));
  }, [dispatch]);

  useEffect(() => {
    setFormSuccessMsg(formSuccess || '');
  }, [formSuccess]);
  useEffect(() => {
    setFormErrorMsg(formError || '');
  }, [formError]);

  const handleFormReset = () => {
    setFormResetKey(prev => prev + 1);
    setFormSuccessMsg('');
    setFormErrorMsg('');
    dispatch(clearStoneSizeEdit());
  };

  const handleSubmit = async (form) => {
    if (editingStoneSize && editingStoneSize.stone_size_id) {
      await dispatch(updateStoneSize(editingStoneSize.stone_size_id, form));
      setFormErrorMsg('');
    } else {
      await dispatch(addStoneSize(form));
      setFormErrorMsg('');
    }
  };

  const handleEdit = (stoneSize) => {
    dispatch(setStoneSizeEdit(stoneSize));
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  const handleDelete = (id) => {
    dispatch(deleteStoneSize(id));
  };

  const handleCancel = () => {
    dispatch(clearStoneSizeEdit());
    setFormSuccessMsg('');
    setFormErrorMsg('');
  };

  // Uniqueness check for code (used in form)
  const checkCodeExists = async (code, excludeId) => {
    const match = list.find(
      ss => ss.stone_size_code === code && (!excludeId || ss.stone_size_id !== excludeId)
    );
    return !!match;
  };

  return (
    <div style={outerWrapper}>
      <style>{responsiveStyle}</style>
      <div style={{ ...containerStyle, className: 'stone-size-flex' }}>
        <div style={{ ...tableContainer, className: 'stone-size-table' }}>
          <StoneSizeTable
            onNew={handleFormReset}
            sieveSizes={sieveSizes}
          />
        </div>
        <div style={{ ...formContainer, className: 'stone-size-form' }}>
          <StoneSizeForm
            key={formResetKey}
            onSubmit={handleSubmit}
            editingStoneSize={editingStoneSize}
            onCancel={handleCancel}
            formSuccess={formSuccessMsg}
            formError={formErrorMsg}
            setFormSuccess={setFormSuccessMsg}
            setFormError={setFormErrorMsg}
            companies={companies}
            sieveSizes={sieveSizes}
            users={users}
            checkCodeExists={checkCodeExists}
          />
        </div>
      </div>
    </div>
  );
};

export default StoneSizePage; 